export class BaseSettingsService {
    async getSettings() {
        throw new Error("Method getSettings() must be implemented");
    }

    async updateSetting(params) {
        throw new Error("Method updateSetting() must be implemented");
    }

    mapResponseToLocalValue(localSettings, response) {
        throw new Error("Method mapResponseToLocalValue() must be implemented");
    }
}